export default function Heading({label, background}:{label:string, background:string}) {


return (
  <div
    className="text-center  text-white p-2 border border-black"
    style={{ background }}
  >
    {label}
  </div>
);
}